export const secondsToMilis = (sec: any) => {
  // toFixed(3) вернет 0.300; toFixed(1) вернет 0.3
  const seconds = sec * 1000;
  return seconds;
};
